
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component({})
export default class FindingStatusChip extends Vue {
    // 0 = needsToCreate, 1 = created
    @VModel() innerValue!: number;
    @Prop({ default: 220 }) maxWidth!: number;

    get chipColor() {
        if (this.innerValue && Number(this.innerValue) > 0) {
            return 'blue';
        }
        return 'blue-grey';
    }

    get chipIcon() {
        if (this.innerValue && Number(this.innerValue) > 0) {
            return 'mdi-clipboard-check-outline';
        }
        return 'mdi-clipboard-plus-outline';
    }

    get label() {
        return this.innerValue && Number(this.innerValue) > 0
            ? this.$t('findings.measureCreated').toString()
            : this.$t('findings.needsToCreateMeasure').toString();
    }

    get chipStyle() {
        return {
            'max-width': this.maxWidth + 'px',
            'white-space': 'nowrap',
        } as any;
    }
}
